/*

Array of object

Top level object can be:
1. Header
2. Group (Group can have navItems as children)
3. navItem

* Supported Options

/--- Header ---/

header

/--- nav Grp ---/

title
icon (if it's on top level)
tag
tagVariant
children

/--- nav Item ---/

icon (if it's on top level)
title
route: [route_obj/route_name] (I have to resolve name somehow from the route obj)
tag
tagVariant

*/

import { getUserData } from '../../auth/utils'

const mainMenu = [
  // GERAL
  {
    header: 'Geral',
  },
  {
    title: 'Dashboard',
    icon: 'HomeIcon',
    route: 'dashboard-main',
  },
  {
    title: 'Central de Atendimento',
    icon: 'MessageCircleIcon',
    route: 'chats',
  },

  // MARKETING
  {
    header: 'Marketing',
  },
  {
    title: 'Audiências',
    icon: 'UsersIcon',
    route: 'audiencia',
  },
  {
    title: 'Campanhas',
    icon: 'SendIcon',
    children: [
      {
        title: 'Inteligentes',
        route: 'campaign-ia',
      },
      {
        title: 'Segmentadas',
        route: 'campaign-todas',
      },
    ],
  },

  // RELATÓRIOS
  {
    header: 'Relatórios',
  },
  {
    title: 'Atendimentos',
    icon: 'ClipboardIcon',
    children: [
      {
        title: 'Visão Geral',
        route: 'chat-operacao-central',
      },
      {
        title: 'Atendentes',
        route: 'chat-desempenho-atendentes',
      },
      {
        title: 'CSAT',
        route: 'chat-relatorio-csat',
      },
      {
        title: 'Etiquetas',
        route: 'chat-etiquetas',
      },
      {
        title: 'Humanizado',
        route: 'dashboard-analytics',
      },
      {
        title: 'IA/BOT',
        route: 'chat-relatorio-ia-bot',
      },
    ],
  },
  {
    title: 'Resultados',
    icon: 'BarChart2Icon',
    children: [
      {
        title: 'Inteligentes',
        route: 'campaign-ia-metricas',
      },
      {
        title: 'Segmentadas',
        route: 'campaign-stores',
      },
    ],
  },
  {
    title: 'Notificações',
    icon: 'BellIcon',
    route: 'dashboard-notifications',
  },

  // SISTEMA
  {
    header: 'Sistema',
  },
  {
    title: 'Configurações',
    icon: 'SettingsIcon',
    children: [
      {
        title: 'Atalhos',
        route: 'chat-atalhos',
      },
      {
        title: 'Atendimento',
        route: 'chat-configuracao-central',
      },
      {
        title: 'Assistentes IA',
        route: 'bot',
      },
      {
        title: 'BOTs',
        route: 'bot-oficial',
      },
      {
        title: 'Lojas',
        route: 'stores',
      },
      {
        title: 'Notificações',
        route: 'notifications-config',
      },
      {
        title: 'Instâncias',
        route: 'stores-connect',
      },
      {
        title: 'Templates',
        route: 'templates',
      },
      {
        title: 'Usuários',
        route: 'users',
      },
    ],
  },
  {
    title: 'Recuperação Humanizada',
    icon: 'InboxIcon',
    route: 'attending',
  },
]

const menu = function () {
  return mainMenu
}

export default menu()
